import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

export default function AutoLogoutPage() {
  const navigate = useNavigate();

  const { signOut } = useAuth();

  useEffect(() => {
    signOut(); // Kijelentkeztetés
    navigate('/'); // Átirányítás a bejelentkezési oldalra
  }, []);

  return null; // Nem jelenít meg semmit
}
